/**
 * Where a house stands, as far as its form depends on it (docs/plans/houses.md, "Typology"):
 * - `main`: the trading streets round the Dam, where the richest lived and the shops stood
 *   (Lesger, Bulletin KNOB 2015, from the 1585 tax; Warmoesstraat c.1560, Stadsherstel);
 * - `lastage`: the shipbuilders' quarter east of the walls, taken into the city only in 1585;
 * - `other`: every other street, quay, lane and shore.
 */
export type HouseSetting = 'main' | 'lastage' | 'other';

const MAIN_SOURCES: readonly string[] = [
  'street-warmoesstraat',
  'street-nieuwendijk',
  'street-kalverstraat',
  'quay-damrak-west',
  'square-dam',
];

/* A lot's source id is its source's name and a running number, as `street-nieuwendijk-3`. */
function sourceName(sourceId: string): string {
  return sourceId.replace(/-\d+$/, '');
}

export function settingOf(sourceId: string): HouseSetting {
  if (sourceId.startsWith('lastage-')) return 'lastage';
  return MAIN_SOURCES.includes(sourceName(sourceId)) ? 'main' : 'other';
}
